import { cloneElement } from 'react';
import { BoxProps, Group, InputElement, InputElementProps } from '@chakra-ui/react';

import { LEGACY_MODE, useMode } from '../Mode';

export interface InputGroupProps extends BoxProps {
  startElementProps?: InputElementProps;
  endElementProps?: InputElementProps;
  startElement?: React.ReactNode;
  endElement?: React.ReactNode;
  children: React.ReactElement;
  ref?: React.RefObject<HTMLDivElement | null>;
}

export function InputGroup({ ref, ...props }: InputGroupProps) {
  const { startElement, startElementProps, endElement, endElementProps, children, ...rest } = props;
  const { mode } = useMode();
  return (
    <Group ref={ref} color="gray.fg" {...rest}>
      {startElement && (
        <InputElement
          pointerEvents="none"
          color={mode === LEGACY_MODE ? 'fg' : 'gray.400'}
          {...startElementProps}
          marginEnd="calc(var(--input-height) - 6px)"
        >
          {startElement}
        </InputElement>
      )}
      {cloneElement(children, {
        ...(startElement && { ps: 'calc(var(--input-height) - 6px)' }),
        ...(endElement && { pe: 'calc(var(--input-height) - 6px)' }),
        ...(children.props as object),
      })}
      {endElement && (
        <InputElement placement="end" color="fg" {...endElementProps}>
          {endElement}
        </InputElement>
      )}
    </Group>
  );
}
